import React, { useState, useEffect } from 'react';
import '@instructure/canvas-theme'
import { FormFieldGroup, FormField } from '@instructure/ui-form-field'
import { TextInput } from '@instructure/ui-text-input'
import { Button } from '@instructure/ui-buttons/es/Button'
import { Alert } from '@instructure/ui-alerts';
import { TextArea } from '@instructure/ui-text-area'
import { instance } from '../axios';
import { withRouter } from 'react-router-dom';
import { Select } from '@instructure/ui-select';
import EmailInfo from '../components/EmailInfo';

function AddPaper(props) {
  const options = [
    { id: 'opt1', label: '教参' },
    { id: 'opt2', label: '教材' },
  ];
  const [alertToggle, setAlertToggle] = useState('none');
  const [message, setMessage] = useState([]);
  const [isShowingOptions, setIsShowingOptions] = useState(false);
  const [selectedOptionId, setSelectedOptionId] = useState(options[0].id);
  const [highlightedOptionId, setHighlightedOptionId] = useState();
  const [objInfo, setObjInfo] = useState({
    jcmc: '', // 书名
    type: options[0].label,  //类型
    doi: '', // DOI
    zzxm: '',// 作者姓名
    cbdw: '', // 出版单位
    cbrq: '',// 出版日期
    abstractInfo: '', // 摘要
    internalId: '',
    id: '', // 教参id
    bsId: '',// 课程id
    userId: '',// 用户id
    isTeacher: '',// 是否为老师
  })
  const params = JSON.parse(localStorage.getItem('urlParams'));

  //  获取存储在sessionStorage里的数据，渲染页面上输入框的数据
  useEffect(() => {
    let objValue = sessionStorage.getItem('paper_info' || '{}');
    if (objValue) {
      const obj = JSON.parse(objValue);
      setObjInfo({
        ...obj,
        id: obj.jcId, // 教参id
      });
    }
  }, []);

  console.log('ObjInfo', objInfo);

  //  统一处理输入框变化
  const handelChangeValue = (name, value) => {
    setObjInfo({ ...objInfo, [name]: value });
    if (name === 'jcmc' && value !== '') {
      setMessage([]);
    }
  };


  // 取消
  const onCancel = () => {
    setObjInfo({
      jcmc: '', // 书名
      type: '',  //类型
      doi: '', // DOI
      zzxm: '',// 作者姓名
      cbdw: '', // 出版单位
      cbrq: '',// 出版日期
      abstractInfo: '', // 摘要
      internalId: '',
      id: '', // 教参id
      bsId: objInfo.bsId,// 课程id
      userId: objInfo.userId,// 用户id
      isTeacher: objInfo.isTeacher,// 是否为老师
    })
    props.history.push(`/guideBooks?userId=` + objInfo.userId + `&courseId=` + objInfo.bsId + `&ghId=` + params.ghId + `&isTeacher=` + objInfo.isTeacher);
  };

  // 新增保存
  const onSave = () => {
    if (objInfo.jcmc === null || objInfo.jcmc === '') {
      setMessage([{ text: '请完善必填项', type: 'error' }])
    } else {
      let parameter = {
        type: objInfo.type,
        bsid: objInfo.bsId,
        doi: objInfo.doi,
        jcmc: objInfo.jcmc,
        cbdw: objInfo.cbdw,
        zzxm: objInfo.zzxm,
        cbrq: objInfo.cbrq,
        abstractInfo: objInfo.abstractInfo,
        gh: params.ghId,
      }
      instance({
        method: 'post',
        url: `addThesisReference`,
        data: parameter
      })
        .then(() => {
          const params = JSON.parse(localStorage.getItem('urlParams'));
          props.history.push(`/guideBooks?userId=` + objInfo.userId + `&courseId=` + objInfo.bsId + `&ghId=` + params.ghId + `&isTeacher=` + objInfo.isTeacher);
        }
        )
        .catch(() => {
          setAlertToggle('block');
          setTimeout(() => {
            setAlertToggle('none');
          }, 3000);
        })
    }
  };

  // 编辑保存
  const onEdit = () => {
    if (objInfo.jcmc === '' || objInfo.jcmc === null) {
      setMessage([{ text: '请完善必填项', type: 'error' }])
    } else {
      let parameter = {
        type: objInfo.type,
        internalId: objInfo.internalId,
        id: objInfo.id,
        bsid: objInfo.bsId,
        doi: objInfo.doi,
        jcmc: objInfo.jcmc,
        cbdw: objInfo.cbdw,
        zzxm: objInfo.zzxm,
        cbrq: objInfo.cbrq,
        abstractInfo: objInfo.abstractInfo,
      }
      console.log(parameter);
      
      instance({
        method: 'post',
        url: `updateReference`,
        data: parameter
      })
        .then(() => {
          props.history.push(`/guideBooks?userId=` + objInfo.userId + `&courseId=` + objInfo.bsId + `&ghId=` + params.ghId + `&isTeacher=` + objInfo.isTeacher);
        })
        .catch(() => { })
    }
  };

  //  教材教参选择
  const getOptionById = (queryId) => {
    return options.find(({ id }) => id === queryId)
  }
  const handleSelectOption = (event, { id }) => {
    const option = getOptionById(id).label
    setSelectedOptionId(id);
    setIsShowingOptions(false);
    setObjInfo({
      ...objInfo,
      type: option,  //类型
    })
  }
  const handleShowOptions = (event) => {
    setIsShowingOptions(true);
  }

  const handleHideOptions = (event) => {
    const option = getOptionById(selectedOptionId)?.label;
    setIsShowingOptions(false);
    setObjInfo({
      ...objInfo,
      type: selectedOptionId ? option : '',  //类型
    })
  }

  const handleHighlightOption = (event, { id }) => {
    event.persist()
    setHighlightedOptionId(id);
  }


  return (
    <div style={{
      marginTop: '100px',
    }}>
      <FormFieldGroup rowSpacing="large" description="" elementRef={e => {console.log(e);
      }}>
        <FormField label="*&nbsp;论文标题:" layout="inline" id='jcmc'>
          <TextInput width="50%" placeholder="请输入" value={objInfo.jcmc} messages={message} onChange={(e, value) => { handelChangeValue('jcmc', value) }} />
        </FormField>
        <FormField label="类型:" layout="inline" id='type'>
          <Select
            renderLabel=""
            inputValue={objInfo && objInfo.type}
            isShowingOptions={isShowingOptions}
            width="50%"
            // onBlur={this.handleBlur}
            onRequestShowOptions={handleShowOptions}//触发了回调，要求显示选项列表。
            onRequestHideOptions={handleHideOptions}//已触发回调，要求隐藏选项列表
            onRequestHighlightOption={handleHighlightOption}//请求特定选项的触发回调将突出显示。
            onRequestSelectOption={handleSelectOption}
          >
            {options.map((option) => {
              return (
                <Select.Option
                  id={option.id}
                  key={option.id}
                  isHighlighted={option.id === highlightedOptionId}
                  isSelected={option.id === selectedOptionId}
                >
                  {option.label}
                </Select.Option>
              )
            })}
          </Select>
        </FormField>
        <FormField layout="inline" label='URL:' id="doi">
          <TextInput width="50%" placeholder="请输入" value={objInfo.doi} onChange={(e, value) => { handelChangeValue('doi', value) }} />
        </FormField>
        <FormField label="*&nbsp;作者（至少一人）:" layout="inline" id="zzxm">
          <TextInput width="50%" placeholder="请输入" value={objInfo.zzxm} onChange={(e, value) => { handelChangeValue('zzxm', value) }} />
        </FormField>
        <FormField label="来源:" layout="inline" id="cbdw">
          <TextInput width="50%" placeholder="请输入" value={objInfo.cbdw} onChange={(e, value) => { handelChangeValue('cbdw', value) }} />
        </FormField>
        <FormField label="时间卷期:" layout="inline" id="cbrq">
          <TextInput width="50%" placeholder="请输入" value={objInfo.cbrq} onChange={(e, value) => { handelChangeValue('cbrq', value) }} />
        </FormField>
        <FormField label="摘要:" layout="inline" id="abstractInfo">
          <div style={{ width: '50%' }}>
            <TextArea
              placeholder="请输入"
              value={objInfo.abstractInfo}
              onChange={(e, value) => { handelChangeValue('abstractInfo', e.target?.value) }}
              maxHeight="10rem"
            />
          </div>
        </FormField>
      </FormFieldGroup>
      <p style={{ textAlign: 'center', marginTop: '20px', width: '80%' }} >
        <Button color="primary-inverse" margin="small" onClick={() => onCancel()}>
          取消
        </Button>
        {objInfo && objInfo.internalId && objInfo.internalId !== '' ?
          <Button color="primary" margin="small" onClick={() => onEdit()}>
            保存
          </Button>
          :
          <Button color="primary" margin="small" onClick={() => onSave()}>
            保存
        </Button>
        }
      </p>
      <div style={alertToggle && alertToggle === 'block' ?
        { display: 'block', zIndex: '99', position: 'fixed', width: '30%', bottom: '0', right: '2% ', textAlign: 'left' } :
        { display: 'none' }}>
        {
          <Alert
            variant={'error'}
            margin="small"
            renderCloseButtonLabel="Close"
          >
            保存失败
          </Alert>
        }
      </div>
      <EmailInfo/>
    </div >
  );
}

export default withRouter(AddPaper);
